import React from 'react'
import LeftBar from '../Components/LeftBar'
import Dashnav from '../Components/Dashnav'
import LearningBreaksComp from './LearningBreaksComp'

function LearningBreaks() {
  return (
    <div className='mainContainer'>
        <LeftBar/>
        <div className='theMainContainer'>
            <Dashnav/>
            <LearningBreaksComp/>
        </div>
    </div>
  )
}

export default LearningBreaks
